import React from 'react';
import './Programs.css';
import ProgramCard from './ProgramCard';

// Import Images
import gconnect_img from '../../assets/programs/engagement_with_parliamentaries/image_1.webp';
import grip_img from '../../assets/programs/grip/image9.webp';
import stem_img from '../../assets/programs/stem_mentorship/image_5.webp';
import ug_anv_img from '../../assets/programs/sci_tech_spins/image1.webp';
import rblitz_img from '../../assets/programs/research_blitz/image1.webp';
import avisit_img from '../../assets/programs/academic_visits/image1.webp';
import future_ch_img from '../../assets/programs/future_changemakers/image3.webp';
import sci_tech_img from '../../assets/programs/sci_tech_spins/image2.webp';

const programsData = [
    { title: "GRIP - Grassroot Innovation Program", href: "grip", image: grip_img },
    { title: "Manasvi: Stem Mentorship Programme", href: "stem-mentorship", image: stem_img },
    { title: "Anveshan: Innovation And Exploration Across Disciplines", href: "anveshan", image: ug_anv_img },
    { title: "Engagement with Parliamentarians", href: "government-connect", image: gconnect_img },
    { title: "Sci-Tech Spins for Schools", href: "sci-tech-spins", image: sci_tech_img},
    { title: "Changemakers", href: "changemakers", image: future_ch_img },
    { title: "Academic Visits", href: "academic-visits", image: avisit_img },
    // { title: "Research Blitz", href: "research-blitz", image: rblitz_img },
];

export default function ProgramsCluster() {
    return (
        <div className="programs-container">
            <div className="programs-header">
                <h1 className="programs-title">Explore Our Programs</h1>
                <p className="programs-description">
                    Through these programs, we strive to bridge the gap between academic excellence and societal needs, inspiring individuals to explore the exciting world of science and technology.
                </p>
            </div>
            <div className="programs">
                {programsData.map((program, index) => (
                    <ProgramCard key={index} title={program.title} href={program.href} image={program.image} />
                ))}
            </div>
        </div>
    );
}
